var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 116,
    viewBox: "0 0 136 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2438_46104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1727 53.7772C18.7539 52.1498 18.7217 48.2531 19.2071 47.4823L28.8468 33.5048C29.2043 32.7995 29.6788 32.2519 30.6214 32.2262L47.1453 31.5363C47.6879 31.5456 53.2001 37.5102 56.799 41.8113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0396 52.9922C29.0396 52.9922 25.4935 60.6204 28.5754 61.1734C29.7303 61.3805 31.098 60.3477 31.098 60.3477C31.098 60.3477 31.0866 62.446 32.7607 63.2945C34.4348 64.143 35.4953 62.0504 35.4953 62.0504C35.4953 62.0504 35.6028 64.1615 37.3701 64.5786C41.7096 61.1389 56.6565 68.041 56.6565 68.041L38.4764 54.0927",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5221 59.5118C30.6601 62.4722 25.9247 61.5718 27.3369 57.3906",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3368 57.3924L27.7725 54.457",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0437 31.0627C45.4997 31.1278 37.7518 31.6549 33.145 31.9789C30.8969 32.1371 28.8423 33.3023 27.5472 35.1467L19.9523 45.9622C18.8 47.6032 18.352 49.637 18.7083 51.6103L18.9878 53.1586",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9541 45.2461L33.0724 52.0751L19.1997 58.8749L11.7055 57.8368L15.6988 51.7587L29.9541 45.2461Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 0.938414
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2583 63.208C40.2583 63.208 45.3114 58.9543 40.4753 55.5138C36.6646 52.4731 30.4895 52.821 28.1735 53.3414C22.6369 55.0416 20.2496 47.6723 26.5991 46.5584L35.5262 44.0034L44.1173 44.2145L55.057 38.8493L66.4116 55.1366C68.7453 62.2667 64.857 69.9387 57.7268 72.2725C53.7277 70.7661 47.4708 70.8275 40.1217 63.8573",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4511 40.8521L56.8226 40.5655C56.8175 40.559 56.8123 40.5526 56.807 40.5464L56.4511 40.8521ZM66.4111 55.1389L66.831 54.9295L66.831 54.9295L66.4111 55.1389ZM57.7263 72.2748L57.5609 72.7139C57.6608 72.7516 57.7707 72.754 57.8722 72.7208L57.7263 72.2748ZM46.3552 68.6511L46.539 68.2194L46.3552 68.6511ZM48.4008 30.7607C48.232 30.5641 47.9357 30.5416 47.7392 30.7105C47.5426 30.8793 47.5201 31.1756 47.689 31.3721L48.4008 30.7607ZM40.0427 63.7674C39.8504 63.5937 39.5537 63.6089 39.38 63.8012C39.2064 63.9936 39.2215 64.2903 39.4139 64.4639L40.0427 63.7674ZM56.4511 40.8521C56.0796 41.1388 56.0796 41.1388 56.0797 41.1389C56.0797 41.1389 56.0798 41.1391 56.0799 41.1392C56.0802 41.1395 56.0805 41.14 56.081 41.1406C56.0819 41.1418 56.0834 41.1437 56.0853 41.1461C56.0891 41.1511 56.0948 41.1585 56.1024 41.1683C56.1175 41.188 56.14 41.2172 56.1695 41.2556C56.2285 41.3324 56.3153 41.4456 56.4266 41.5912C56.6491 41.8823 56.9693 42.3027 57.3597 42.8194C58.1406 43.8529 59.2017 45.2712 60.3232 46.8106C62.5769 49.9043 65.0408 53.4423 65.9912 55.3483L66.831 54.9295C65.8384 52.9391 63.3223 49.3337 61.0817 46.2581C59.9561 44.713 58.8915 43.2901 58.1085 42.2537C57.7169 41.7354 57.3956 41.3136 57.1721 41.0213C57.0604 40.8751 56.9731 40.7613 56.9137 40.6839C56.884 40.6453 56.8612 40.6157 56.8459 40.5958C56.8382 40.5859 56.8324 40.5783 56.8285 40.5733C56.8266 40.5707 56.8251 40.5688 56.8241 40.5675C56.8236 40.5669 56.8232 40.5664 56.823 40.566C56.8228 40.5659 56.8227 40.5657 56.8227 40.5657C56.8226 40.5656 56.8226 40.5655 56.4511 40.8521ZM65.9912 55.3483C67.5844 58.5435 67.2254 62.0812 65.5848 65.1269C63.9419 68.177 61.0278 70.7005 57.5803 71.8289L57.8722 72.7208C61.5549 71.5154 64.6571 68.828 66.411 65.572C68.1672 62.3116 68.5856 58.4483 66.831 54.9295L65.9912 55.3483ZM57.8917 71.8358C55.8662 71.0728 54.0704 70.6171 52.2717 70.1299C50.4705 69.6421 48.6526 69.1195 46.539 68.2194L46.1714 69.0828C48.3459 70.0088 50.214 70.5448 52.0264 71.0357C53.8414 71.5273 55.5871 71.9705 57.5609 72.7139L57.8917 71.8358ZM56.807 40.5464L48.4008 30.7607L47.689 31.3721L56.0952 41.1579L56.807 40.5464ZM46.539 68.2194C45.077 67.5969 43.4578 66.492 42.188 65.5255C41.5568 65.0451 41.0192 64.6044 40.6396 64.284C40.4499 64.1239 40.2999 63.9941 40.1977 63.9046C40.1466 63.8598 40.1074 63.8252 40.0813 63.8019C40.0682 63.7902 40.0583 63.7814 40.0519 63.7756C40.0486 63.7727 40.0462 63.7706 40.0447 63.7692C40.0439 63.7685 40.0434 63.768 40.0431 63.7677C40.0429 63.7676 40.0428 63.7675 40.0427 63.7674C40.0427 63.7674 40.0427 63.7674 40.0427 63.7674C40.0427 63.7674 40.0427 63.7674 39.7283 64.1157C39.4139 64.4639 39.4139 64.464 39.414 64.464C39.414 64.4641 39.4141 64.4641 39.4142 64.4642C39.4143 64.4644 39.4145 64.4646 39.4148 64.4648C39.4154 64.4653 39.4161 64.466 39.4171 64.4668C39.419 64.4686 39.4218 64.4711 39.4255 64.4744C39.4328 64.4809 39.4435 64.4905 39.4575 64.5029C39.4854 64.5278 39.5264 64.5641 39.5795 64.6105C39.6855 64.7034 39.8399 64.8371 40.0344 65.0012C40.4232 65.3293 40.9733 65.7802 41.6196 66.2722C42.9046 67.2503 44.5988 68.4132 46.1714 69.0828L46.539 68.2194Z",
    fill: "#2B3F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9264 46.6852L32.2643 41.5225C32.8101 41.0779 33.4461 40.762 34.1322 40.6042C36.3082 40.1038 41.283 39.0047 42.965 39.0138",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1384 43.2263C50.0461 44.2521 48.1603 48.3581 44.0645 46.7148",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7077 61.6329C34.8788 64.5943 30.3727 63.1213 31.5225 59.5117",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3171 62.918C39.5048 65.8905 34.8919 64.6455 35.7076 61.6339",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1909 63.2664L41.3672 56.3203",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7073 61.631L36.958 54.7148",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5217 59.5098L32.5488 53.1094",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3851 68.1549C44.2809 64.9533 45.31 58.9527 40.4738 55.5121C36.6631 52.4714 30.4881 52.8193 28.1721 53.3397C22.6355 55.0399 20.2481 47.6707 26.5976 46.5567C26.5976 46.5567 32.7807 44.7539 35.1005 44.8388C37.3554 44.9212 44.0641 46.7167 44.0641 46.7167",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9256 43.3992C54.8685 42.9687 55.2838 41.8553 54.8533 40.9124L56.5605 40.1328C57.4216 42.0186 56.591 44.2454 54.7052 45.1065L47.0225 48.6146C46.5511 48.8299 45.9944 48.6222 45.7791 48.1508C45.5638 47.6793 45.7715 47.1226 46.243 46.9074L53.9256 43.3992Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 0.938413
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7965 32.7119C57.4465 31.9585 59.395 32.6853 60.1484 34.3354L60.5382 35.189C61.2917 36.8391 60.5649 38.7875 58.9148 39.541L55.9271 40.9052L52.8088 34.0762L55.7965 32.7119Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 0.938413
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8086 34.0781L55.9269 40.9072L46.1494 46.4788L35.1104 44.1572L52.8086 34.0781Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 0.938413
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4473 44.2461L60.4201 45.1257L56.7559 72.2068L68.2834 75.02L72.4473 44.2461Z",
    fill: "white",
    stroke: "#2B3F5F",
    strokeWidth: 0.938413
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.804 54.4906C110.747 40.9419 74.9279 42.036 72.4628 44.1452L68.4055 74.1308C73.4557 84.9476 115.036 85.0715 134.802 112.563L134.354 83.6633L134.804 54.4906Z",
    fill: "#2B3F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.861 55.0002L134.916 113.238C124.893 99.7031 108.893 92.8123 95.8177 87.9426C93.0854 86.925 90.441 85.9998 87.9374 85.124C84.2824 83.8453 80.9278 82.6716 78.0387 81.469C75.6114 80.4585 73.5413 79.4384 71.9263 78.3354C70.3616 77.2669 69.2575 76.143 68.6564 74.9129L72.769 44.5181C72.8874 44.4546 73.0713 44.3781 73.3367 44.2969C73.7226 44.1789 74.2331 44.0647 74.8614 43.9594C76.1167 43.749 77.8126 43.5791 79.8632 43.4786C83.9629 43.2777 89.4555 43.3556 95.6297 43.9331C107.909 45.0818 122.841 48.2027 134.861 55.0002ZM73.1481 43.3933C72.7358 43.5193 72.3764 43.6705 72.1478 43.8694L72.01 43.9894L67.7996 75.106L67.8601 75.2381C68.5421 76.729 69.8084 77.9989 71.4828 79.1423C73.1611 80.2884 75.2856 81.3316 77.7308 82.3495C80.6331 83.5577 84.0276 84.7456 87.7046 86.0323C90.2063 86.9077 92.8388 87.8289 95.5359 88.8334C108.91 93.8144 125.116 100.858 134.98 114.828L135.696 115.841L135.696 54.4136L135.474 54.2868C123.286 47.3273 108.129 44.1601 95.7259 42.9998C89.5206 42.4194 83.9934 42.3402 79.8564 42.543C77.7887 42.6443 76.0622 42.8163 74.7688 43.0331C74.1227 43.1414 73.5773 43.262 73.1481 43.3933Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2438_46104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.5658,
    height: 67.5658,
    fill: "white",
    transform: "translate(31.0049 0.335938) rotate(26.8767)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.271be4917fed31a9c64eda87a73d584b.svg";
export { ForwardRef as ReactComponent };